import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    NullableBooleanInput,
    required,
    SelectInput,
} from 'react-admin';

import { Banners } from '../../custom';
import FileUpload from '../../common/inputs/FileUpload';
import { EditToolbar } from '../../common/EditToolbar';
import { STATUSES } from '../../common/constants';

const DoubtEdit = () => (
    <Edit title={<BannerTitle />}>
        <SimpleForm toolbar={<EditToolbar />}>
            <FileUpload
                type="VIDEO_THUMBNAIL"
                source={'image'}
                required={true}
                accept={'image/*'}
            />
            <TextInput source={'title'} fullWidth validate={[required()]} />
            <TextInput source={'content'} fullWidth validate={[required()]} />
            <NullableBooleanInput source="featured" fullWidth label={'Featured'} />
            <SelectInput
                source="status"
                label={'Status'}
                fullWidth
                validate={[required()]}
                choices={STATUSES}
            />
        </SimpleForm>
    </Edit>
);

const BannerTitle = () => {
    const record = useRecordContext<Banners>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.banners.name', { smart_count: 1 })} &quot;
            {record.display_order}&quot;
        </span>
    ) : null;
};

export default DoubtEdit;
